import { Component, OnInit, Output, Input, EventEmitter, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { AddressSearchService } from 'src/app/shared';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, map } from 'rxjs/operators';
import { AlertModal } from 'src/app/model/alert';
import { ModalComponent } from '../modal/modal.component';
import { ToolTipNotificationComponent } from '../../form-elements/tool-tip-notification/tool-tip-notification.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-address-search',
    templateUrl: './address-search.component.html',
    styleUrls: ['./address-search.component.scss'],
    imports: [NgClass, ToolTipNotificationComponent, ModalComponent]
})
export class AddressSearchComponent implements OnInit, OnDestroy {

  public resultAddress: any[];
  public suggestiontext: any[];
  searchTerm$ = new Subject<string>();
  isListAddressEnabled = true;
  noRecordFound = true;
  private subscription;
  public contentData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() addressChoosen: EventEmitter<any> = new EventEmitter<any>();
  @Input() tooltipData: any;
  textValue: string;
  displayTooltipAlert = false;
  tooltipModal;
  public tooltipModalConfig: AlertModal;
  constructor(private addressSearchService: AddressSearchService,
    private eRef: ElementRef,
    private activatedRoute: ActivatedRoute
  ) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.addressSearch;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }

  ngOnInit() {
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;

    this.subscription = this.searchTerm$.pipe(map(res => res),debounceTime(200)).subscribe(res => {
      this.isListAddressEnabled = true;
      if (res.length >= 1) {
        this.addressSearchService.searchAddress(res)
          .subscribe((results: any[]) => {
            this.resultAddress = results;
            if (results !== undefined && this.resultAddress.length >= 1) {
              this.noRecordFound = false;
              this.suggestiontext = this.resultAddress.filter(r => r.Type === 'Address').map(r => `${r.Text || ''} ${r.Description || ''}`.trim());
            } else {
              this.addressSearchService.searchDummyAddress()
                .subscribe(resdummy => {
                  this.noRecordFound = true;
                  this.suggestiontext = resdummy.map((r: { suggestion: any; }) => r.suggestion);
                }
                );
            }
          });
      } else {
        this.suggestiontext = null;
      }
    }
    );
  }

  onSelectAddress(selectedAddress) {
    if (!this.noRecordFound) {
      const selectedItem = this.resultAddress.find(a => selectedAddress === `${a.Text || ''} ${a.Description || ''}`.trim());
      this.addressSearchService.getFormattedAddress(selectedItem?.['Id']).subscribe(
        result => {
          const mappedData: any = this.addressSearchService.mapFormattedAddress(result[0]);
          this.addressChoosen.emit(mappedData);
        }
      );
    }
  }

  @HostListener('document:click', ['$event'])
  public clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
      this.isListAddressEnabled = true;
    } else {
      this.isListAddressEnabled = false;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  displayTooltipMessage() {
    let config;

    config = this.tooltipData;
    this.tooltipModal.content = config.content;
    this.displayTooltipAlert = true;
  }

  closeTooltipModal() {
    this.displayTooltipAlert = false;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
  alertSecondaryBtnClick() {
    this.closeTooltipModal();
  }
}
